import { HierarchyRectangularNode } from '@visx/hierarchy/lib/types';
import { useCallback } from 'react';

import type { Point } from '../../core/types/point.js';
import { useSetState } from '../store/selectors.js';
import type { InternalTreeMapNode } from '../types/internal.js';

export const useTooltip = () => {
  const setState = useSetState();

  const setTooltipContent = useCallback(
    (tooltipContent: HierarchyRectangularNode<InternalTreeMapNode>) => {
      setState((prev) => ({
        ...prev,
        tooltip: {
          ...prev.tooltip,
          content: tooltipContent,
        },
      }));
    },
    [setState],
  );

  const setTooltipVisible = useCallback(
    (isVisible: boolean) => {
      setState((prev) => ({
        ...prev,
        tooltip: {
          ...prev.tooltip,
          visible: isVisible,
        },
      }));
    },
    [setState],
  );

  const setTooltipPinned = useCallback(
    (isPinned: boolean) => {
      setState((prev) => ({
        ...prev,
        tooltip: {
          ...prev.tooltip,
          pinned: isPinned,
        },
      }));
    },
    [setState],
  );

  const setTooltipPosition = useCallback(
    (position: Point) => {
      setState((prev) => {
        return {
          ...prev,
          tooltip: {
            ...prev.tooltip,
            position,
          },
        };
      });
    },
    [setState],
  );

  return {
    setTooltipContent,
    setTooltipPinned,
    setTooltipVisible,
    setTooltipPosition,
  };
};
